// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PatientTaskSearch-module__patientSearchWrap___C2Y24 {
  min-width: 0;
  flex: 0 0 auto;
  position: relative;
}

.PatientTaskSearch-module__patientSearchInput___SDXnF {
  width: 244px;
  position: relative;
}

.PatientTaskSearch-module__patientSearchIcon___KkSK_ {
  position: absolute;
  left: 10px;
  top: 50%;
  width: 13px;
  height: 13px;
  transform: translateY(-50%);
  color: #a1a1aa;
  opacity: 0.65;
  pointer-events: none;
  z-index: 1;
}

.PatientTaskSearch-module__patientSearchNativeInput___DEIHJ {
  width: 100%;
  height: 27px;
  padding: 0 30px 0 30px;
  border: 1px solid #d4d4d8;
  border-radius: 5px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  font-size: 14px;
  color: #18181b;
  outline: none;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}

.PatientTaskSearch-module__patientSearchNativeInputSelected___h2p55 {
  background: #fafafa;
  border-color: #d4d4d8;
  color: #3f3f46;
  font-size: 13px;
  font-weight: 500;
}

.PatientTaskSearch-module__patientSearchNativeInput___DEIHJ::placeholder {
  color: #a1a1aa;
}

.PatientTaskSearch-module__patientSearchNativeInput___DEIHJ:focus {
  border-color: #a1a1aa;
}

.PatientTaskSearch-module__patientSearchClearIcon___GOrth {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  color: #a1a1aa;
  font-size: 15px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
}

.PatientTaskSearch-module__patientSearchDropdown___bby0f {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 324px;
  max-height: 320px;
  overflow-y: auto;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 12px;
  box-shadow: 0 18px 32px rgba(15, 23, 42, 0.12);
  z-index: 20;
}

.PatientTaskSearch-module__patientSearchDropdownHeader___jBjiP {
  padding: 10px 14px;
  border-bottom: 1px solid #f1f5f9;
  background: #fafafa;
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
}

.PatientTaskSearch-module__patientSearchResult___l8vwE {
  width: 100%;
  border: none;
  border-bottom: 1px solid #f1f5f9;
  background: transparent;
  padding: 12px 14px;
  text-align: left;
  cursor: pointer;
  transition: background 120ms ease;
}

.PatientTaskSearch-module__patientSearchResult___l8vwE:hover {
  background: #fafafa;
}

.PatientTaskSearch-module__patientSearchResult___l8vwE:last-child {
  border-bottom: none;
}

.PatientTaskSearch-module__patientSearchOption___hVfGf {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.PatientTaskSearch-module__patientSearchOptionHeader___ha7H3 {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}

.PatientTaskSearch-module__patientSearchOptionName___mSL5n {
  font-size: 14px;
  font-weight: 600;
  color: #27272a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.PatientTaskSearch-module__patientSearchOptionMrn___ON1Nr {
  font-size: 12px;
  color: #a1a1aa;
  white-space: nowrap;
}

.PatientTaskSearch-module__patientSearchOptionMeta___gKmPs {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex-wrap: wrap;
}

.PatientTaskSearch-module__patientSearchOptionPathway___Vwy5w {
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  padding: 0 6px;
  border: 1px solid #d4d4d8;
  border-radius: 4px;
  background: #fafafa;
  color: #3f3f46;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
}

.PatientTaskSearch-module__patientSearchOptionPhase___CCTa9,
.PatientTaskSearch-module__patientSearchOptionClinician___MCW0b {
  font-size: 12px;
  color: #a1a1aa;
  white-space: nowrap;
}

.PatientTaskSearch-module__patientSearchEmpty___gXVOD {
  padding: 16px 14px;
  font-size: 13px;
  color: #a1a1aa;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/PatientTaskSearch/PatientTaskSearch.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,cAAA;EACA,aAAA;EACA,oBAAA;EACA,UAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,0DACE;AAAJ;;AAIA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,qBAAA;AADF;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;AADF;;AAIA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,8CAAA;EACA,WAAA;AADF;;AAIA;EACE,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,gCAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,YAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;;EAEE,eAAA;EACA,cAAA;EACA,mBAAA;AADF;;AAIA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AADF","sourcesContent":[".patientSearchWrap {\n  min-width: 0;\n  flex: 0 0 auto;\n  position: relative;\n}\n\n.patientSearchInput {\n  width: 244px;\n  position: relative;\n}\n\n.patientSearchIcon {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  width: 13px;\n  height: 13px;\n  transform: translateY(-50%);\n  color: #a1a1aa;\n  opacity: 0.65;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.patientSearchNativeInput {\n  width: 100%;\n  height: 27px;\n  padding: 0 30px 0 30px;\n  border: 1px solid #d4d4d8;\n  border-radius: 5px;\n  background: #ffffff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  font-size: 14px;\n  color: #18181b;\n  outline: none;\n  transition:\n    border-color 120ms ease,\n    box-shadow 120ms ease;\n}\n\n.patientSearchNativeInputSelected {\n  background: #fafafa;\n  border-color: #d4d4d8;\n  color: #3f3f46;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.patientSearchNativeInput::placeholder {\n  color: #a1a1aa;\n}\n\n.patientSearchNativeInput:focus {\n  border-color: #a1a1aa;\n}\n\n.patientSearchClearIcon {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  background: transparent;\n  color: #a1a1aa;\n  font-size: 15px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0;\n}\n\n.patientSearchDropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  width: 324px;\n  max-height: 320px;\n  overflow-y: auto;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 12px;\n  box-shadow: 0 18px 32px rgba(15, 23, 42, 0.12);\n  z-index: 20;\n}\n\n.patientSearchDropdownHeader {\n  padding: 10px 14px;\n  border-bottom: 1px solid #f1f5f9;\n  background: #fafafa;\n  font-size: 12px;\n  font-weight: 500;\n  color: #94a3b8;\n}\n\n.patientSearchResult {\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid #f1f5f9;\n  background: transparent;\n  padding: 12px 14px;\n  text-align: left;\n  cursor: pointer;\n  transition: background 120ms ease;\n}\n\n.patientSearchResult:hover {\n  background: #fafafa;\n}\n\n.patientSearchResult:last-child {\n  border-bottom: none;\n}\n\n.patientSearchOption {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.patientSearchOptionHeader {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  min-width: 0;\n}\n\n.patientSearchOptionName {\n  font-size: 14px;\n  font-weight: 600;\n  color: #27272a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.patientSearchOptionMrn {\n  font-size: 12px;\n  color: #a1a1aa;\n  white-space: nowrap;\n}\n\n.patientSearchOptionMeta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  flex-wrap: wrap;\n}\n\n.patientSearchOptionPathway {\n  display: inline-flex;\n  align-items: center;\n  min-height: 20px;\n  padding: 0 6px;\n  border: 1px solid #d4d4d8;\n  border-radius: 4px;\n  background: #fafafa;\n  color: #3f3f46;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1;\n}\n\n.patientSearchOptionPhase,\n.patientSearchOptionClinician {\n  font-size: 12px;\n  color: #a1a1aa;\n  white-space: nowrap;\n}\n\n.patientSearchEmpty {\n  padding: 16px 14px;\n  font-size: 13px;\n  color: #a1a1aa;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"patientSearchWrap": `PatientTaskSearch-module__patientSearchWrap___C2Y24`,
	"patientSearchInput": `PatientTaskSearch-module__patientSearchInput___SDXnF`,
	"patientSearchIcon": `PatientTaskSearch-module__patientSearchIcon___KkSK_`,
	"patientSearchNativeInput": `PatientTaskSearch-module__patientSearchNativeInput___DEIHJ`,
	"patientSearchNativeInputSelected": `PatientTaskSearch-module__patientSearchNativeInputSelected___h2p55`,
	"patientSearchClearIcon": `PatientTaskSearch-module__patientSearchClearIcon___GOrth`,
	"patientSearchDropdown": `PatientTaskSearch-module__patientSearchDropdown___bby0f`,
	"patientSearchDropdownHeader": `PatientTaskSearch-module__patientSearchDropdownHeader___jBjiP`,
	"patientSearchResult": `PatientTaskSearch-module__patientSearchResult___l8vwE`,
	"patientSearchOption": `PatientTaskSearch-module__patientSearchOption___hVfGf`,
	"patientSearchOptionHeader": `PatientTaskSearch-module__patientSearchOptionHeader___ha7H3`,
	"patientSearchOptionName": `PatientTaskSearch-module__patientSearchOptionName___mSL5n`,
	"patientSearchOptionMrn": `PatientTaskSearch-module__patientSearchOptionMrn___ON1Nr`,
	"patientSearchOptionMeta": `PatientTaskSearch-module__patientSearchOptionMeta___gKmPs`,
	"patientSearchOptionPathway": `PatientTaskSearch-module__patientSearchOptionPathway___Vwy5w`,
	"patientSearchOptionPhase": `PatientTaskSearch-module__patientSearchOptionPhase___CCTa9`,
	"patientSearchOptionClinician": `PatientTaskSearch-module__patientSearchOptionClinician___MCW0b`,
	"patientSearchEmpty": `PatientTaskSearch-module__patientSearchEmpty___gXVOD`
};
module.exports = ___CSS_LOADER_EXPORT___;
